module.exports = __webpack_public_path__ + "img/move-in-boxes.dbba0913.jpg";